/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortDto } from './sortDto';
import { IdReferenceDto } from './idReferenceDto';
import { SelectedRangeDto } from './selectedRangeDto';


export interface InspectionFilterDto { 
    tenantId?: string;
    internalTenantId?: string;
    buildingId?: string;
    status?: InspectionFilterDto.StatusEnum;
    normType?: InspectionFilterDto.NormTypeEnum;
    inspectionType?: InspectionFilterDto.InspectionTypeEnum;
    continuationNumber?: number;
    technicianReference?: IdReferenceDto;
    clerkReference?: IdReferenceDto;
    selectedRange?: SelectedRangeDto;
    condition?: InspectionFilterDto.ConditionEnum;
    fullTextSearch?: string;
    teamId?: string;
    regionId?: string;
    assignedToCurrentUser?: boolean;
    text?: string;
    page?: number;
    sort?: SortDto;
    size?: number;
}
export namespace InspectionFilterDto {
    export type StatusEnum = 'DRAFT' | 'TODO' | 'IN_PROGRESS' | 'IN_REVIEW' | 'DONE' | 'SENT' | 'NONE';
    export const StatusEnum = {
        Draft: 'DRAFT' as StatusEnum,
        Todo: 'TODO' as StatusEnum,
        InProgress: 'IN_PROGRESS' as StatusEnum,
        InReview: 'IN_REVIEW' as StatusEnum,
        Done: 'DONE' as StatusEnum,
        Sent: 'SENT' as StatusEnum,
        None: 'NONE' as StatusEnum
    };
    export type NormTypeEnum = 'NORM_1300' | 'NORM_1301';
    export const NormTypeEnum = {
        Norm1300: 'NORM_1300' as NormTypeEnum,
        Norm1301: 'NORM_1301' as NormTypeEnum
    };
    export type InspectionTypeEnum = 'REGULAR' | 'SCHADSTELLENPLAN';
    export const InspectionTypeEnum = {
        Regular: 'REGULAR' as InspectionTypeEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as InspectionTypeEnum
    };
    export type ConditionEnum = 'NO_DEFECTS' | 'MINOR_DEFECTS' | 'MAJOR_DEFECTS' | 'NONE';
    export const ConditionEnum = {
        NoDefects: 'NO_DEFECTS' as ConditionEnum,
        MinorDefects: 'MINOR_DEFECTS' as ConditionEnum,
        MajorDefects: 'MAJOR_DEFECTS' as ConditionEnum,
        None: 'NONE' as ConditionEnum
    };
}


